import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { format, parse, parseISO } from 'date-fns'

@Pipe({
  name: 'dateformat'
})
export class ToDateObjPipe implements PipeTransform {
    // transform(value: string): string {
    //     const [datePart, timePart] = value.split(', ');
    //     const [day, month, year] = datePart.split('/');
    //     const [hours, minutes, seconds] = timePart.split(':');
    //     const processedDate = parse(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}`, 'yyyy-MM-dd\'T\'HH:mm:ss', new Date());
    
    //     return format(processedDate, 'h:mm a');
    //   }


    // transform(value: string): string {
    //     const [datePart, timePart] = value.split(', ');
    //     const [day, month, year] = datePart.split('/');
    //     const [hours, minutes, seconds] = timePart.split(':');
    //     const isoString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
        
    //     // Ensure compatibility across browsers
    //     const processedDate = parseISO(isoString);
    
    //     return format(processedDate, 'h:mm a');
    //   }


//     constructor(private datePipe: DatePipe) {}

//   transform(value: string): string {
//     const [datePart, timePart] = value.split(', ');
//     const [day, month, year] = datePart.split('/');
//     const [hours, minutes, seconds] = timePart.split(':');
//     const isoString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

//     // Use DatePipe to ensure compatibility in both Safari and Chrome
//     const parsedDate = this.parseDateString(isoString);

//     return this.datePipe.transform(parsedDate, 'h:mm a');
//   }

//   private parseDateString(dateString: string): Date {
//     const [datePart, timePart] = dateString.split('T');
//     const [year, month, day] = datePart.split('-');
//     const [hours, minutes, seconds] = timePart.split(':');

//     //return new Date(+year, +month - 1, +day, +hours, +minutes, +seconds);
//     let newDate = new Date(+year, +month - 1, +day, +hours, +minutes, +seconds);
//     console.log("newDate pipe => ", newDate)
//     return newDate;
//   }


transform(value: string): string {
    const [datePart, timePart] = value.split(', ');
    const [day, month, year] = datePart.split('/');

    // Construct a standardized date string with MM/DD/YYYY format
    const standardizedDateString = `${month}/${day}/${year} ${timePart}`;

    // Create a Date object from the standardized string
    const parsedDate = new Date(standardizedDateString);

    // Format the date using Date.toLocaleTimeString
    const formattedTime = parsedDate.toLocaleTimeString(undefined, {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });

    return formattedTime;
  }
}